function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "abstract");

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 701,
  y: 661,
  width: 394.74023,
  height: 2,
  fill: "#3f3d56"
});

var _ref4 = /*#__PURE__*/React.createElement("polygon", {
  points: "474 429 474 216 718 216 718 0 0 0 0 643 718 643 718 429 474 429",
  fill: "#3f3d56"
});

var _ref5 = /*#__PURE__*/React.createElement("polygon", {
  points: "718 216 718 0 469 0 469 213 249 213 249 0 0 0 0 216 225 216 225 429 0 429 0 643 476 643 476 429 474 429 474 216 718 216",
  opacity: 0.1
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M224.12988,117.98284a172.00382,172.00382,0,0,1-172,172v-172Z",
  transform: "translate(-52.12988 -117.98284)",
  fill: "#194a50"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M132.12988,117.98284a80.00357,80.00357,0,0,1-80,80v44a124.00426,124.00426,0,0,0,124-124Z",
  transform: "translate(-52.12988 -117.98284)",
  opacity: 0.1
});

var _ref8 = /*#__PURE__*/React.createElement("polygon", {
  points: "718 60 718 29 553 29 553 0 517 0 517 29 517 60 517 84 517 115 553 115 718 115 718 84 553 84 553 60 718 60",
  fill: "#d0cde1"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M481.12988,448.98284a81,81,0,1,0-92,80.23639V642.98284H256.36627a81,81,0,1,0,0,22H389.12988v48h22v-48h45v-22h-45V529.21923A81.00034,81.00034,0,0,0,481.12988,448.98284Z",
  transform: "translate(-52.12988 -117.98284)",
  fill: "#d0cde1"
});

var _ref10 = /*#__PURE__*/React.createElement("polygon", {
  points: "626.5 445.263 662.508 507.631 698.517 570 626.5 570 554.483 570 590.492 507.631 626.5 445.263",
  fill: "#d0cde1"
});

var _ref11 = /*#__PURE__*/React.createElement("polygon", {
  points: "610.5 578 538.483 578 574.492 515.631 574.742 515.198 561.5 492.263 525.492 554.631 489.483 617 561.5 617 633.517 617 611 578 610.5 578",
  fill: "#194a50"
});

var _ref12 = /*#__PURE__*/React.createElement("polygon", {
  points: "159 345 159 291 186 291 186 259 52 259 52 393 186 393 186 345 159 345",
  fill: "#d0cde1"
});

var _ref13 = /*#__PURE__*/React.createElement("rect", {
  x: 89,
  y: 234,
  width: 50,
  height: 50,
  fill: "#194a50"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M989.162,357.83165,972.618,401.5551l-59.664,20.935s-36-4-36,16c0,14.18058,43,2,43,2l78.66169-23.57271,24.816-61.44917Z",
  transform: "translate(-52.12988 -117.98284)",
  fill: "#ffb8b8"
});

var _ref15 = /*#__PURE__*/React.createElement("rect", {
  x: 635,
  y: 228,
  width: 234,
  height: 202,
  fill: "#194a50"
});

var _ref16 = /*#__PURE__*/React.createElement("polygon", {
  points: "747.5 289.263 783.508 351.631 819.517 414 747.5 414 675.483 414 711.492 351.631 747.5 289.263",
  fill: "#3f3d56"
});

var _ref17 = /*#__PURE__*/React.createElement("polygon", {
  points: "747.331 334.415 763.665 362.708 780 391 747.331 391 714.661 391 730.996 362.708 747.331 334.415",
  fill: "#d0cde1"
});

var _ref18 = /*#__PURE__*/React.createElement("polygon", {
  points: "747.331 242.415 763.665 270.708 780 299 747.331 299 714.661 299 730.996 270.708 747.331 242.415",
  fill: "#d0cde1"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M1024.15387,329.42035s-16.544-2.36343-24.816,28.36116-10.63544,33.088-10.63544,33.088,48.45031,7.09029,49.632,4.72686S1048.96988,336.51064,1024.15387,329.42035Z",
  transform: "translate(-52.12988 -117.98284)",
  fill: "#2f2e41"
});

var _ref20 = /*#__PURE__*/React.createElement("circle", {
  cx: 962.57027,
  cy: 167.71406,
  r: 31.9063,
  fill: "#ffb8b8"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M1000.51957,311.69463s10.63544,27.17944,7.09029,30.72459,43.72345,8.272,43.72345,8.272,3.54515-17.72572-10.63543-28.36116c0,0-5.90858-17.72572-4.72686-21.27087S1000.51957,311.69463,1000.51957,311.69463Z",
  transform: "translate(-52.12988 -117.98284)",
  fill: "#ffb8b8"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M1028.88073,323.51178a85.216,85.216,0,0,0-31.9063,21.27087c-14.18058,15.36229-21.27087,20.08915-21.27087,20.08915s-16.544,5.90857-10.63544,34.26973c2.95429,14.18058.88629,30.13373-1.92028,42.54174a265.8223,265.8223,0,0,0-6.35172,58.65559v12.2473s-108.71777,228.071-72.08461,243.43328,69.72118,20.08915,72.08461,16.544,44.90517-187.89267,44.90517-187.89267,11.81715,197.34639,41.36,197.34639,77.99318-8.272,77.99318-8.272l-60.26746-236.343s14.18058-40.17831-21.27087-68.53947l-4.72686-12.99886c19.60447.01,28.56614-124.06968,8.272-134.7155C1043.06131,321.14835,1038.33445,317.6032,1028.88073,323.51178Z",
  transform: "translate(-52.12988 -117.98284)",
  fill: "#2f2e41"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M999.33786,387.32438l-16.544,43.72345-59.664,20.935s-36-4-36,16c0,14.18058,43,2,43,2l78.6617-23.57271,24.816-61.44918Z",
  transform: "translate(-52.12988 -117.98284)",
  fill: "#ffb8b8"
});

var _ref24 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 868.62393,
  cy: 652.21718,
  rx: 20.68001,
  ry: 11.81715,
  fill: "#2f2e41"
});

var _ref25 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 1026.97373,
  cy: 652.21718,
  rx: 20.68001,
  ry: 11.81715,
  fill: "#2f2e41"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M1027.01734,240.95422h-.00012a25.34145,25.34145,0,0,0-4.89258.48651,21.44172,21.44172,0,0,0-9.34021-2.15271h-.84777c-16.34473,0-29.59461,14.7901-29.59461,33.03461v.00006h5.47669l.88452-6.73224L990,272.32269h4.56226a64.57589,64.57589,0,0,0-2.119,16.55036v33.62384h8.28027l4.79395-12.45795-1.19849,12.45795h53.22314l4.35816-11.32538-1.0896,11.32538h5.99243V296.09613C1066.80311,265.64215,1048.99037,240.95422,1027.01734,240.95422Z",
  transform: "translate(-52.12988 -117.98284)",
  fill: "#2f2e41"
});

var SvgUndrawAbstractX68E = function SvgUndrawAbstractX68E(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a5860ba0-ef67-4914-ac96-07e2ebcccb4f",
    "data-name": "Layer 1",
    width: 1095.74023,
    height: 664.03433,
    viewBox: "0 0 1095.74023 664.03433",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUndrawAbstractX68E, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/undraw_abstract_x68e.4c467ee9.svg";
export { ForwardRef as ReactComponent };